import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import '../assets/css/button.scss';
let ButtonMixin = class ButtonMixin extends Vue {
  get iconObj() {
    // 旧数据兼容（原为yxt-icon string类型）
    return this.icon ? typeof this.icon === 'string' ? {
      iconType: 'default',
      value: this.icon
    } : {
      iconType: this.icon.iconType || '',
      value: this.icon.value || ''
    } : {
      iconType: 'default',
      value: ''
    };
  }
  get iconType() {
    return this.iconObj.iconType;
  }
  get iconName() {
    return this.iconObj.value;
  }
  get buttonClass() {
    let classes = [];
    this.isHidden && classes.push('is-hidden');
    this.isDisabled && classes.push('is-disabled');
    return classes.join(' ');
  }
  get isPlain() {
    return this.borderType == 'plain';
  }
  get isRound() {
    return this.borderType == 'round';
  }
  get isCircle() {
    return this.borderType == 'circle';
  }
  get isDisabled() {
    return this.behavivor == 'disabled';
  }
  get isHidden() {
    return this.behavivor == 'hidden';
  }
  get buttonTitle() {
    var _this$title;
    let tit = (_this$title = this.title) === null || _this$title === void 0 ? void 0 : _this$title.trim();
    return tit === '按钮' ? window.lowcode.i18n.get('apaas_amui_button_label', '按钮') : tit;
  }
};
__decorate([Prop()], ButtonMixin.prototype, "title", void 0);
__decorate([Prop({
  default: 'primary'
})], ButtonMixin.prototype, "type", void 0);
__decorate([Prop({
  default: 'medium'
})], ButtonMixin.prototype, "size", void 0);
__decorate([Prop({
  default: 'normal'
})], ButtonMixin.prototype, "behavivor", void 0);
__decorate([Prop()], ButtonMixin.prototype, "icon", void 0);
__decorate([Prop({
  default: 'left'
})], ButtonMixin.prototype, "iconAlign", void 0);
__decorate([Prop()], ButtonMixin.prototype, "borderType", void 0);
__decorate([Prop({
  default: false
})], ButtonMixin.prototype, "loading", void 0);
__decorate([Prop({
  default: false
})], ButtonMixin.prototype, "autofocus", void 0);
ButtonMixin = __decorate([Component({
  name: 'ButtonMixin'
})], ButtonMixin);
export default ButtonMixin;